"use strict";
import Api from "../../api/api";
import DisablingButton from "../disabling_button";
import ToolbarLink from "./toolbar_link";
import {
  addComponent,
  saveAnnotations,
  toggleToneSliders,
  toggleCropping
} from "../redux/actions";
const addRedaction = (props) => () => {
  props.dispatch(addComponent("Redaction"));
};
const addText = (props) => () => {
  props.dispatch(addComponent("TextAnnotation"));
};
const addStamp = (props) => () => {
  props.dispatch(addComponent("Stamp"));
};
const fireSaveAnnotations = (props) => () => {
  props.onProcessAttachment();
  props.dispatch(saveAnnotations(props.page));
};
const fireToggleToneSliders = (props) => () => {
  props.dispatch(toggleToneSliders());
};
const fireToggleCropping = (props) => () => {
  props.dispatch(toggleCropping());
};
const stampButton = (props) => {
  if (props.annotationStampUrl) {
    return /* @__PURE__ */ React.createElement(
      ToolbarLink,
      {
        icon: "stamp",
        enabled: !props.attachmentIsProcessing,
        action: addStamp(props),
        title: "Add stamp"
      }
    );
  }
};
const toneAdjustmentButton = (props) => {
  const settings = Api.Account.currentSettings();
  if (settings.tone_adjustments_enabled) {
    return /* @__PURE__ */ React.createElement(
      ToolbarLink,
      {
        icon: "graph-bar",
        enabled: !props.attachmentIsProcessing,
        action: fireToggleToneSliders(props),
        title: "Edit image attributes",
        active: props.editingTone
      }
    );
  }
};
const cropButton = (props) => {
  const settings = Api.Account.currentSettings();
  if (settings.tone_adjustments_enabled) {
    return /* @__PURE__ */ React.createElement(
      ToolbarLink,
      {
        icon: "crop",
        enabled: !props.attachmentIsProcessing,
        action: fireToggleCropping(props),
        title: "Crop",
        active: props.cropping
      }
    );
  }
};
const textButton = (props) => {
  const settings = Api.Account.currentSettings();
  return /* @__PURE__ */ React.createElement(
    ToolbarLink,
    {
      icon: "text-color",
      enabled: !props.attachmentIsProcessing,
      action: addText(props),
      title: "Add Text",
      active: false
    }
  );
};
const AnnotateToolbar = (props) => {
  if (props.allowsEditing && props.annotating && document) {
    return /* @__PURE__ */ React.createElement("div", { className: "document-browser__pod-status page-toolbar__bar" }, /* @__PURE__ */ React.createElement(
      ToolbarLink,
      {
        icon: "page-remove",
        enabled: !props.attachmentIsProcessing,
        action: addRedaction(props),
        title: "Redact",
        active: false
      }
    ), toneAdjustmentButton(props), stampButton(props), textButton(props), cropButton(props), /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        onClick: fireSaveAnnotations(props),
        disabled: props.attachmentIsProcessing,
        disabledText: "Saving\u2026",
        className: "button--progress",
        style: {
          float: "right",
          padding: "5px 10px",
          marginBottom: 0,
          fontSize: "0.8em"
        }
      },
      "Save Annotations"
    ));
  }
};
AnnotateToolbar.propTypes = {
  allowsEditing: React.PropTypes.bool,
  editingTone: React.PropTypes.bool,
  showToneSliders: React.PropTypes.bool,
  annotating: React.PropTypes.bool,
  dispatch: React.PropTypes.func,
  onProcessAttachment: React.PropTypes.func,
  savingAnnotations: React.PropTypes.bool,
  annotationStampUrl: React.PropTypes.string,
  cropping: React.PropTypes.bool,
  page: React.PropTypes.object
};
export default AnnotateToolbar;
